module.exports = "<div class=\"page-load-animation\">\r\n</div>\r\n<wk-loading></wk-loading>\r\n<router-outlet></router-outlet>\r\n"